import {
	Button,
	Checkbox,
	Col,
	DatePicker,
	Form,
	Input,
	Row,
	Select,
	Upload,
	notification,
} from "antd";
import React, { useEffect, useState } from "react";
import Layout from "../layout/Layout";
import { api } from "../utils/Api";
import axios from "axios";
import {
	customerTypeOptions,
	federalTaxClassificationOptions,
	franchises57Options,
	notifiableOptions,
	paymentTermOptions,
	quadrantTypeOptions,
	rankingOptions,
} from "../../constants/Customer";
import dayjs from "dayjs";
import { UploadOutlined } from "@ant-design/icons";

const { Option } = Select;

const CustomerProfileNew = ({ history }) => {
	const [form] = Form.useForm();
	const [loading, setLoading] = useState(true);
	const [customerNumber, setCustomerNumber] = useState("");
	const [apiNotification, contextHolder] = notification.useNotification();
	const [sellerOptions, setSellerOptions] = useState([]);
	const [franchise, setFranchise] = useState("57Concrete");
	const [isCredit, setIsCredit] = useState(false);
	const [initialValues, setInitialValues] = useState({});

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	useEffect(() => {
		getCustomerNumber();
		getSellerList();
	}, []);

	const getCustomerNumber = async () => {
		const url = api + "/customernumber";
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			setCustomerNumber("A" + data.customerNumber.toString());
			setLoading(false);

			setInitialValues({
				prefix: "+1",
				paymentType: "PrePay",
				state: "TX",
				accountsPayableFax: "",
				accountsPayableEmail: "",
				notifiableEvents: [
					{ value: "newJob", label: "New Job" },
					{ value: "newLoad", label: "New Load" },
					{ value: "newEticket", label: "New Eticket" },
				],
				cashAccount: true,
				creditAccount: false,
				paymentTerm: "Prepayment",
				assignedSalesRep: localStorage.getItem("userName"),
				customerNumber: "A" + data.customerNumber.toString(),
				date: dayjs(),
				franchise: "57Concrete",
			});
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const duplicatedUserPhone = async (phone) => {
		const url = api + `/userphone/+1${phone}`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			return data.found;
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const duplicatedUserEmail = async (email) => {
		const url = api + "/useremail/" + email;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			return data.found;
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const getSellerList = async () => {
		const url = api + "/user/list/57Concrete/Seller";
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			if (data.success) {
				let list = [];
				data.payload.map((item, index) => {
					list.push({
						key: index,
						value: item._id,
						label: item.name,
					});
				});
				setSellerOptions(list);
			}
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const createCompany = async (datas) => {
		try {
			const formData = new FormData();

			const user = {
				name: datas.contactName,
				email: datas.email,
				phone: `+1${datas.sms}`,
				password: "Concrete2026",
				role: "Customer",
				franchise: datas.franchise || "57Concrete",
			};

			if (datas.signedW9Form && datas.signedW9Form.length > 0) {
				formData.append("signedW9Form", datas.signedW9Form[0].originFileObj);
			}
			if (datas.creditApplication && datas.creditApplication.length > 0) {
				formData.append(
					"creditApplication",
					datas.creditApplication[0].originFileObj,
				);
			}

			const company = {
				name: datas.name,
				email: datas.email,
				sms: `+1${datas.sms}`,
				customerType: datas.customerType,
				quadrantType: datas.quadrantType,
				contactName: datas.contactName,
				dba: datas.dba,
				taxId: datas.taxId,
				contactPosition: datas.contactPosition,
				customerNumber: customerNumber,
				notifiableEvents: datas.notifiableEvents,
				address: datas.address,
				city: datas.city,
				state: datas.state,
				zip: datas.zip,
				county: datas.county,
				contactPhone: `+1${datas.sms}`,
				accountsPayableContact: datas.accountsPayableContact,
				accountsPayableEmail: datas.accountsPayableEmail,
				accountsPayablePhone: `+1${datas.accountsPayablePhone}`,
				paymentType: datas.cashAccount ? "PrePay" : "Credit",
				paymentTerm: datas.paymentTerm,
				federalTaxClassification: datas.federalTaxClassification,
				franchise: datas.franchise || "57Concrete",
				createdBy: localStorage.getItem("userId"),
				ranking: datas.ranking,
				prospectionType: "Regular",
				prospectionSeller: datas.prospectionSeller,
			};

			if (datas.notifiableEvents) {
				let values = [];
				datas.notifiableEvents.map((item) => {
					values.push({
						value: item.value,
						label: item.label,
					});
				});
				company.notifiableEvents = values;
			}

			formData.append("company", JSON.stringify(company));
			formData.append("user", JSON.stringify(user));

			const url = api + "/customer/profile/create";
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
			const { data } = await axios.post(url, formData, {
				headers: {
					"Content-Type": "multipart/form-data",
				},
			});

			if (data.success) {
				openNotification("success", "Success", data.message);
				setTimeout(() => {
					history.push(`/clientconfirmation/${data.payload._id}`);
				}, 3000);
			} else {
				openNotification("error", "Error", data.message);
			}
			setLoading(false);
		} catch (err) {
			setLoading(false);
			openNotification("error", "Error", "Error while trying to create user");
			console.error(err);
			return null;
		}
	};

	const validateUser = async (values) => {
		const duplicadoEmail = await duplicatedUserEmail(values.email);
		const duplicadoPhone = await duplicatedUserPhone(values.sms);

		if (duplicadoEmail) {
			openNotification(
				"warning",
				"Duplicated user",
				"User already exist with Email",
			);
			setLoading(false);
		} else if (duplicadoPhone) {
			openNotification(
				"warning",
				"Duplicated user",
				"User already exist with Phone",
			);
			setLoading(false);
		} else {
			createCompany(values);
		}
	};

	const onFinish = () => {
		setLoading(true);
		const values = form.getFieldsValue(true);
		validateUser(values);
	};

	const prefixSelector = (
		<Form.Item name="prefix" noStyle>
			<Select
				style={{
					width: 70,
				}}
			>
				<Option value="+1">+1</Option>
			</Select>
		</Form.Item>
	);

	const filterOption = (input, option) =>
		(option?.label ?? "").toLowerCase().includes(input.toLowerCase());

	const onChangeFranchise = (v) => {
		if (v === "Valley Wide") {
			form.setFieldValue("prospectionSeller", "68d340ee5307a2f6813f110f");
		} else {
			form.setFieldValue("prospectionSeller", undefined);
		}
		setFranchise(v);
	};

	const CustomForm = () => {
		return (
			<Form
				form={form}
				layout="vertical"
				onFinish={onFinish}
				initialValues={initialValues}
			>
				<Row gutter={16}>
					<Col span={24} md={12}>
						<Form.Item
							label="Legal Company Name"
							name="name"
							rules={[
								{
									required: true,
									message: "Please fill company name",
								},
							]}
						>
							<Input size="large" />
						</Form.Item>
					</Col>
					<Col span={24} md={6}>
						<Form.Item
							label="DBA"
							name="dba"
							rules={[
								{
									required: true,
									message: "Please fill DBA",
								},
							]}
						>
							<Input size="large" />
						</Form.Item>
					</Col>
					<Col span={24} md={6}>
						<Form.Item
							label="EIN/Tax ID (W-9)"
							name="taxId"
							rules={[
								{
									required: true,
									message: "Please fill EIN/Tax ID",
								},
							]}
						>
							<Input size="large" />
						</Form.Item>
					</Col>
					<Col span={24} md={12}>
						<Form.Item
							label="Customer Type"
							name="customerType"
							rules={[
								{
									required: true,
									message: "Please select customer type",
								},
							]}
						>
							<Select
								showSearch
								placeholder={`Select customer type`}
								optionFilterProp="children"
								size="large"
								filterOption={filterOption}
								options={customerTypeOptions}
								style={{
									width: "100%",
								}}
							/>
						</Form.Item>
					</Col>
					<Col span={24} md={12}>
						<Form.Item
							label="Quadrant Type"
							name="quadrantType"
							rules={[
								{
									required: true,
									message: "Please select quadrant type",
								},
							]}
						>
							<Select
								showSearch
								placeholder={`Select quadrant type`}
								optionFilterProp="children"
								size="large"
								filterOption={filterOption}
								options={quadrantTypeOptions}
								style={{
									width: "100%",
								}}
							/>
						</Form.Item>
					</Col>
				</Row>
				<Row gutter={16}>
					<Col span={24} md={12}>
						<Form.Item
							label="Primary Contact Name"
							name="contactName"
							rules={[
								{
									required: true,
									message: "Please fill name",
								},
							]}
						>
							<Input size="large" />
						</Form.Item>
					</Col>
					<Col span={24} md={12}>
						<Form.Item
							label="Title / Position"
							name="contactPosition"
							rules={[
								{
									required: true,
									message: "Please fill name",
								},
							]}
						>
							<Input size="large" />
						</Form.Item>
					</Col>
					<Col span={24} md={12}>
						<Form.Item
							label="Primary Contact Phone"
							name="sms"
							rules={[
								{
									required: true,
									message: "Please fill phone",
								},
								{
									len: 10,
									max: 10,
									message: "Phone number must have 10 numbers",
								},
							]}
						>
							<Input size="large" addonBefore={prefixSelector} />
						</Form.Item>
					</Col>
					<Col span={24} md={12}>
						<Form.Item
							label="Primary Contact Email"
							name="email"
							rules={[
								{
									type: "email",
									message: "The input is not valid E-mail",
								},
								{
									required: true,
									message: "Please fill email",
								},
							]}
						>
							<Input size="large" />
						</Form.Item>
					</Col>
				</Row>
				<Row gutter={16}>
					<Col span={24}>
						<Form.Item label="Notifiable Events" name="notifiableEvents">
							<Select
								showSearch
								labelInValue
								placeholder={`Select notifiable events`}
								size="large"
								mode="multiple"
								options={notifiableOptions}
								style={{
									width: "100%",
								}}
							/>
						</Form.Item>
					</Col>
				</Row>
				<Row gutter={16}>
					<Col span={24} md={8}>
						<Form.Item
							label="Company Address"
							name="address"
							rules={[
								{
									required: true,
									message: "Please fill address",
								},
							]}
						>
							<Input size="large" />
						</Form.Item>
					</Col>

					<Col span={24} md={4}>
						<Form.Item
							label="City"
							name="city"
							rules={[
								{
									required: true,
									message: "Please fill city",
								},
							]}
						>
							<Input size="large" />
						</Form.Item>
					</Col>
					<Col span={24} md={4}>
						<Form.Item
							label="State"
							name="state"
							rules={[
								{
									required: true,
									message: "Please fill state",
								},
							]}
						>
							<Input size="large" />
						</Form.Item>
					</Col>

					<Col span={24} md={4}>
						<Form.Item
							label="ZIP Code"
							name="zip"
							rules={[
								{
									required: true,
									message: "Please fill zip",
								},
							]}
						>
							<Input size="large" />
						</Form.Item>
					</Col>
					<Col span={24} md={4}>
						<Form.Item
							label="County"
							name="county"
							rules={[
								{
									required: true,
									message: "Please fill county",
								},
							]}
						>
							<Input size="large" />
						</Form.Item>
					</Col>
				</Row>
				<Row gutter={16}>
					<Col span={24} md={8}>
						<Form.Item
							label="Primary A/P Contact Name"
							name="accountsPayableContact"
							rules={[
								{
									required: true,
									message: "Please fill contact name",
								},
							]}
						>
							<Input size="large" />
						</Form.Item>
					</Col>
					<Col span={24} md={8}>
						<Form.Item
							label="Primary A/P Contact Phone"
							name="accountsPayablePhone"
							rules={[
								{
									required: true,
									message: "Please fill phone",
								},
								{
									len: 10,
									max: 10,
									message: "Phone number must have 10 numbers",
								},
							]}
						>
							<Input size="large" addonBefore={prefixSelector} />
						</Form.Item>
					</Col>
					<Col span={24} md={8}>
						<Form.Item
							label="Primary A/P Contact Email"
							name="accountsPayableEmail"
							rules={[
								{
									type: "email",
									message: "The input is not valid E-mail",
								},
								{
									required: true,
									message: "Please fill email",
								},
							]}
						>
							<Input size="large" />
						</Form.Item>
					</Col>
				</Row>

				<Row gutter={16}>
					<Col span={24} md={8}>
						<Form.Item name="cashAccount" valuePropName="checked">
							<Checkbox
								onChange={(e) => {
									if (e.target.checked) {
										form.setFieldValue("creditAccount", false);
										form.setFieldValue("paymentTerm", "Prepayment");
										setIsCredit(false);
									} else {
										form.setFieldValue("creditAccount", true);
										form.setFieldValue("paymentTerm", "7");
										setIsCredit(true);
									}
								}}
							>
								Cash Account ( Prepayment or COD - no credit terms extended)
							</Checkbox>
						</Form.Item>
					</Col>
					<Col span={24} md={8}>
						<Form.Item name="creditAccount" valuePropName="checked">
							<Checkbox
								onChange={(e) => {
									if (e.target.checked) {
										form.setFieldValue("cashAccount", false);
										form.setFieldValue("paymentTerm", "7");
										setIsCredit(true);
									} else {
										form.setFieldValue("cashAccount", true);
										form.setFieldValue("paymentTerm", "Prepayment");
										setIsCredit(false);
									}
								}}
							>
								Credit Account ( Credit App required - Tab 2)
							</Checkbox>
						</Form.Item>
					</Col>
					<Col span={24} md={8}>
						<Form.Item
							label="Payment Term"
							name="paymentTerm"
							rules={[
								{
									required: true,
									message: "Please select payment term",
								},
							]}
						>
							<Select
								showSearch
								placeholder={`Select payment term`}
								optionFilterProp="children"
								size="large"
								filterOption={filterOption}
								options={paymentTermOptions}
								style={{
									width: "100%",
								}}
								// disabled={!isCredit}
								disabled={true}
							/>
						</Form.Item>
					</Col>
					<Col span={24} md={12}>
						<Form.Item
							label="Federal Tax Classification"
							name="federalTaxClassification"
							rules={[
								{
									required: true,
									message: "Please select federal tax classification",
								},
							]}
						>
							<Select
								showSearch
								placeholder={`Select federal tax classification`}
								optionFilterProp="children"
								size="large"
								filterOption={filterOption}
								options={federalTaxClassificationOptions}
								style={{
									width: "100%",
								}}
							/>
						</Form.Item>
					</Col>
					<Col span={24} md={6}>
						<Form.Item
							label="Signed W-9 Form Attached"
							name="signedW9Form"
							valuePropName="fileList"
							getValueFromEvent={normFile}
						>
							<Upload
								beforeUpload={() => false}
								maxCount={1}
								multiple={false}
								accept=".pdf"
							>
								<Button icon={<UploadOutlined />} size="large">
									Upload
								</Button>
							</Upload>
						</Form.Item>
					</Col>
					<Col span={24} md={6}>
						<Form.Item
							label="Credit Application Attached"
							name="creditApplication"
							valuePropName="fileList"
							getValueFromEvent={normFile}
						>
							<Upload
								beforeUpload={() => false}
								maxCount={1}
								multiple={false}
								accept=".pdf"
							>
								<Button icon={<UploadOutlined />} size="large">
									Upload
								</Button>
							</Upload>
						</Form.Item>
					</Col>
				</Row>
				<Row gutter={16}>
					<Col span={24} md={8}>
						<Form.Item
							label="Ranking"
							name="ranking"
							rules={[
								{
									required: true,
									message: "Please select ranking",
								},
							]}
						>
							<Select
								showSearch
								placeholder={`Select ranking`}
								optionFilterProp="children"
								size="large"
								filterOption={filterOption}
								options={rankingOptions}
								style={{
									width: "100%",
								}}
							/>
						</Form.Item>
					</Col>
					{(localStorage.getItem("email") === "vm@57concrete.com" ||
						localStorage.getItem("email") === "eliud@gmail.com" ||
						localStorage.getItem("email") === "jc@57concrete.com" ||
						localStorage.getItem("email") === "pc@57concrete.com" ||
						localStorage.getItem("email") === "ec@57concrete.com" ||
						localStorage.getItem("email") === "gg@57xgroup.com") && (
						<Col span={24} md={8}>
							<Form.Item
								label="Franchise"
								name="franchise"
								rules={[
									{
										required: true,
										message: "Please select franchise",
									},
								]}
							>
								<Select
									showSearch
									placeholder={`Select franchise`}
									optionFilterProp="children"
									options={franchises57Options}
									allowClear={false}
									style={{
										width: "100%",
									}}
									size={"large"}
									onChange={onChangeFranchise}
								/>
							</Form.Item>
						</Col>
					)}
					<Col span={24} md={8}>
						<Form.Item
							label="Seller"
							name="prospectionSeller"
							rules={[
								{
									required: true,
									message: "Please select seller",
								},
							]}
						>
							<Select
								showSearch
								placeholder={`Select payment seller`}
								optionFilterProp="children"
								size="large"
								filterOption={filterOption}
								options={sellerOptions}
								style={{
									width: "100%",
								}}
								disabled={franchise === "Valley Wide"}
							/>
						</Form.Item>
					</Col>
					<Col span={24} md={8}>
						<Form.Item
							label="Assigned Sales Representative"
							name="assignedSalesRep"
						>
							<Input size="large" disabled />
						</Form.Item>
					</Col>
					<Col span={24} md={8}>
						<Form.Item label="Customer Account #" name="customerNumber">
							<Input size="large" disabled />
						</Form.Item>
					</Col>
					<Col span={24} md={8}>
						<Form.Item label="Date of Submission" name="date">
							<DatePicker
								size="large"
								disabled
								format="MM/DD/YYYY hh:mm A"
								style={{
									width: "100%",
								}}
							/>
						</Form.Item>
					</Col>
				</Row>

				<Button type="primary" htmlType="submit" loading={loading} size="large">
					Create
				</Button>
			</Form>
		);
	};

	const normFile = (e) => {
		if (Array.isArray(e)) {
			return e;
		}
		return e?.fileList;
	};

	return (
		<Layout
			title="Customer Profile"
			description="Create new Customer Profile"
			type="medium"
		>
			{contextHolder}
			<CustomForm />
		</Layout>
	);
};

export default CustomerProfileNew;
